import React, { useState, useEffect } from "react";
import MultipleEmailForm from "./MultipleEmailForm";
import { MultiSelect } from "react-multi-select-component";
import { base_url } from "../../Global";
import { db, loginAdmin } from "../../Firebase";
import { collection, getDocs } from "firebase/firestore";

const RecipientSelector = ({ appName, onSelectionChange }) => {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [extraEmails, setExtraEmails] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        if (appName === "lxdc") {
          const response = await fetch(base_url + "/auth/allProfile");
          if (!response.ok) throw new Error("Failed to fetch LXDC users");
          const data = await response.json();
          setUsers(
            data?.users
              ?.filter((u) => !!u.username?.trim())
              ?.map((u) => ({
                value: u._id,
                label: u.username,
                email: u.email,
              })) || [],
          );
        } else if (appName === "vortex") {
          await loginAdmin();
          const userSnapshot = await getDocs(collection(db, "users"));
          const usersList = userSnapshot.docs.map((doc) => ({
            id: doc.id,
            uid: doc.data().uid || doc.id,
            ...doc.data(),
          }));
          setUsers(
            usersList
              ?.filter((u) => !!u.name?.trim())
              ?.map((u) => ({
                value: u.id || u.uid,
                label: u.name,
                email: u.email,
              })) || [],
          );
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchUsers();
  }, [appName]);

  useEffect(() => {
    const combined = [
      ...users.filter(u => selectedUsers.some(s => s.value === u.value)).map(u => ({ id: u.value, email: u.email })),
      ...extraEmails
    ];
    onSelectionChange(combined);
  }, [selectedUsers, extraEmails, users, onSelectionChange]);

  const removeEmail = (i) => setExtraEmails(extraEmails.filter((_, index) => index !== i));
  const addEmail = (data) => setExtraEmails([...extraEmails, { email: data?.Enteremail }]);

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6 space-y-6">
      <div className="space-y-2">
        <label className="text-xs font-bold text-slate-400 uppercase tracking-widest">Select Recipients</label>
        <MultiSelect
          className="text-slate-900"
          valueRenderer={(selected) =>
            selected.length
              ? `${selected.length} Users Selected`
              : "No Users Selected"
          }
          options={users}
          value={selectedUsers}
          onChange={setSelectedUsers}
          labelledBy="Search and select users..."
        />
      </div>
      
      <div className="pt-4 border-t border-slate-50">
        <label className="text-xs font-bold text-slate-400 uppercase tracking-widest block mb-2">Additional Emails</label>
        <MultipleEmailForm
          onDelete={removeEmail}
          Emails={extraEmails}
          onAdd={addEmail}
        />
      </div>
    </div>
  );
};

export default RecipientSelector;
